(function () {
  'use strict';

  angular
    .module('web2print')
    .service('floatingFaqInitializer', floatingFaqInitializer);

  floatingFaqInitializer.$inject = ['$q'];

  /* @ngInject */
  function floatingFaqInitializer ($q) {
    const d = $q.defer();

    Humany.configure(function (config) {
      config.navigationMode('hashless');

      Humany.ready(function () {
        d.resolve();
      });
    });

    return d.promise;
  }
})();
